import { createContext } from 'react';

const ProgressDayContext = createContext();

export default ProgressDayContext;